/** 列表/待办 activityAt：后端 uiHints 计算，不直接使用 updatedAt */
export const getOrderDisplayActivityAt = (order) => order?.uiHints?.activityAt ?? null;

/** 待办「进入当前栏」时间：后端按 Tab 挂载 uiHints.queueEnteredAt */
export const getOrderDisplayQueueEnteredAt = (order) => order?.uiHints?.queueEnteredAt ?? null;

/** 待办 NEW 标记时间窗（刚进入当前待办栏） */
export const ORDER_RECENT_QUEUE_ENTERED_WINDOW_MS = 8 * 60 * 60 * 1000;

/** 是否在 NEW 时间窗内（用于待办列表标记） */
export const isOrderRecentlyEnteredQueue = (order, windowMs = ORDER_RECENT_QUEUE_ENTERED_WINDOW_MS, now = Date.now()) => {
	const at = getOrderDisplayQueueEnteredAt(order);
	if (!at) return false;
	const time = new Date(at).getTime();
	if (Number.isNaN(time)) return false;
	const age = now - time;
	return age >= 0 && age <= windowMs;
};
